import { useEffect, useState } from 'react';
import PartnerService from '../Services/partner.service';
import { isPartnershipClient } from '../Utils/partners/partnersEquityDistribution';

/** Partners of the client's case; always [] for non-partnership clients. */
export const useCasePartners = (client, token) => {
  const [partners, setPartners] = useState([]);
  const caseId = client?.caseId;
  const isPartnership = isPartnershipClient(client);

  useEffect(() => {
    if (!isPartnership || !caseId || !token) {
      setPartners([]);
      return undefined;
    }

    let cancelled = false;
    const fetchPartners = async () => {
      try {
        const response = await PartnerService.getPartnersByCaseId(caseId, token);
        if (!response.ok) {
          if (!cancelled) setPartners([]);
          return;
        }
        const data = await response.json();
        if (!cancelled) setPartners(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error fetching partners:', error);
        if (!cancelled) setPartners([]);
      }
    };

    fetchPartners();
    return () => {
      cancelled = true;
    };
  }, [caseId, isPartnership, token]);

  return partners;
};

export default useCasePartners;
